import { render, staticRenderFns } from "./Template8.vue?vue&type=template&id=f53ead5a&scoped=true&"
import script from "./Template8.vue?vue&type=script&lang=js&"
export * from "./Template8.vue?vue&type=script&lang=js&"
import style0 from "./Template8.vue?vue&type=style&index=0&id=f53ead5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53ead5a",
  null
  
)

export default component.exports